import { createFileRoute, redirect, type SearchSchemaInput } from '@tanstack/react-router';
import { sessionQuery } from '@/services/session';
import { parseSlackLinkSearch, type SlackLinkSearchInput } from '@/features/slack-link/link-search';
import { SlackLinkPage } from '@/features/slack-link/slack-link-page';

export const Route = createFileRoute('/slack/link')({
  // A plain validator, not zod: everything outside the component sits in the entry the sign-in page pays for.
  validateSearch: (search: SlackLinkSearchInput & SearchSchemaInput) => parseSlackLinkSearch(search),
  // Signed out? Sign in, then come back to this link (the token rides in returnTo).
  beforeLoad: async ({ context: { queryClient }, location }) => {
    const user = await queryClient.ensureQueryData(sessionQuery).catch(() => null);
    if (!user) throw redirect({ to: '/auth/signin', search: { returnTo: location.href } });
  },
  component: SlackLinkRoute,
});

function SlackLinkRoute() {
  const { token } = Route.useSearch();
  return <SlackLinkPage token={token ?? null} />;
}
